// src/pages/Beheerdersportaal.js (updated version)
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Masonry from 'react-masonry-css';
import BeheerdersportaalSidebar from '../components/BeheerdersportaalSidebar';
import '../css/Beheerdersportaal.css';
import RecentNewsletterWidget from '../components/RecentNewsletterWidget';
import JubileeWidget from '../components/JubileeWidget';
import Statistics from '../components/Statistics';
import CustomModal from '../components/CustomModal';
import UpcomingEventsWidget from '../components/UpcomingEventsWidget';
import DegreeDaysUsageWidget from '../components/DegreeDaysUsageWidget'; 
import KenterEnergyWidget from '../components/KenterEnergyWidget';
import WidgetEnergyComare from '../components/WidgetEnergyCompare';
import '../css/PageWithSidebar.css';
import KenterSyncNotification from '../components/KenterSyncNotification';

const Beheerdersportaal = () => {
  const [showStatisticsModal, setShowStatisticsModal] = useState(false);
  const [showAllEventsModal, setShowAllEventsModal] = useState(false);
  const [showAllJubileesModal, setShowAllJubileesModal] = useState(false);
  const [allEvents, setAllEvents] = useState([]);
  const [allJubilees, setAllJubilees] = useState([]);
  
  // Function to open Statistics modal
  const openStatisticsModal = () => {
    setShowStatisticsModal(true);
  };
  
  // Function to handle view all events
  const handleViewAllEvents = (events) => {
    setAllEvents(events);
    setShowAllEventsModal(true);
  };
  
  // Function to handle view all jubilees
  const handleViewAllJubilees = (jubilees) => {
    setAllJubilees(jubilees);
    setShowAllJubileesModal(true);
  };

  // Format event for the all events modal
  const formatEvent = (event) => (
    <li key={event.id} style={{ marginBottom: '8px' }}>
      <strong>{new Date(event.start.dateTime || event.start.date).toLocaleDateString('nl-NL')}</strong>
      {event.start.dateTime ? ` ${new Date(event.start.dateTime).toLocaleTimeString('nl-NL', { hour: '2-digit', minute: '2-digit' })}` : ''}
        : {event.summary}
      <div style={{ fontSize: '0.8em', color: 'gray' }}>({event.calendarLabel})</div>
    </li>
  );
  
  return (
    // The BeheerdersportaalSidebar now wraps the entire page including the dashboard
    <BeheerdersportaalSidebar>
      <main className="dashboard">
        <h1>🏠 Polder Portaal</h1>
        
        {/* Sync Notification - shows prominently at the top when needed */}
        <KenterSyncNotification />
        
        <div className="dashboard-content">
          {/* Masonry grid with widgets */}
          <Masonry
            breakpointCols={{
              default: 3, // 3 columns on large screens
              1200: 3,    // 3 columns on medium screens
              800: 2,     // 2 columns on smaller tablets
              600: 1      // 1 column on mobile
            }}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            
            {/* Event card */}
            <div className="card">
              <UpcomingEventsWidget onViewAllClick={handleViewAllEvents} />
            </div>

            <div className="card">
              {/* Energy Comparison Widget */}
              <KenterEnergyWidget />
            </div>

             {/* Jubilee Widget */}
             <JubileeWidget onViewAllClick={handleViewAllJubilees} />
            
            <div className="card">
              <WidgetEnergyComare />
            </div>
            
            {/* Newsletter widget */}
            <RecentNewsletterWidget onViewStatistics={openStatisticsModal} />
          </Masonry>
        </div>
        
        {/* Modals */}
        <CustomModal 
          isOpen={showStatisticsModal} 
          onClose={() => setShowStatisticsModal(false)}
          title="Email Statistics"
          isStatistics={true}
        >
          <Statistics />
        </CustomModal>
        
        <CustomModal isOpen={showAllEventsModal} onClose={() => setShowAllEventsModal(false)}>
          <h2>Alle Afspraken</h2>
          <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
            {allEvents.map(event => formatEvent(event))}
          </ul>
        </CustomModal>
        
        <CustomModal isOpen={showAllJubileesModal} onClose={() => setShowAllJubileesModal(false)}>
          <h2>Alle Bewoners Jubilea</h2>
          <div style={{ marginBottom: '16px' }}>
            <p>Een overzicht van alle aankomende jubilea van bewoners in ons gebouw.</p>
          </div>
          <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '2px solid #ddd' }}>Naam</th>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '2px solid #ddd' }}>Nummer</th>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '2px solid #ddd' }}>Jubileum</th>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '2px solid #ddd' }}>Datum</th>
                  <th style={{ textAlign: 'left', padding: '8px', borderBottom: '2px solid #ddd' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {allJubilees
                  .filter(jubilee => jubilee.daysUntil >= 0)
                  .sort((a, b) => a.jubileeDate - b.jubileeDate)
                  .map((jubilee, index) => (
                    <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '8px' }}>{jubilee.naam}</td>
                      <td style={{ padding: '8px' }}>{jubilee.nummer}</td>
                      <td style={{ padding: '8px' }}>
                        <span style={{ 
                          padding: '2px 6px',
                          borderRadius: '4px',
                          backgroundColor: jubilee.jubileeType === 25 || jubilee.jubileeType === 50 ? '#fff3e0' : '#f0f7ff',
                          color: jubilee.jubileeType === 25 || jubilee.jubileeType === 50 ? '#e65100' : '#0066cc',
                          fontWeight: '500'
                        }}>
                          {jubilee.jubileeType === 12.5 ? '12½' : jubilee.jubileeType} jaar
                        </span>
                      </td>
                      <td style={{ padding: '8px' }}>
                        {new Date(jubilee.jubileeDate).toLocaleDateString('nl-NL')}
                      </td>
                      <td style={{ padding: '8px' }}>
                        {jubilee.daysUntil === 0 ? (
                          <span style={{ color: '#e53935', fontWeight: 'bold' }}>Vandaag!</span>
                        ) : jubilee.daysUntil <= 30 ? (
                          <span style={{ color: '#ff9800' }}>Over {jubilee.daysUntil} dagen</span>
                        ) : (
                          <span style={{ color: '#777' }}>Over {jubilee.daysUntil} dagen</span>
                        )}
                      </td>
                    </tr>
                  ))
                }
                {allJubilees.filter(jubilee => jubilee.daysUntil >= 0).length === 0 && (
                  <tr>
                    <td colSpan="5" style={{ padding: '16px', textAlign: 'center' }}>
                      Geen aankomende jubilea gevonden.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </CustomModal>
      </main>
    </BeheerdersportaalSidebar>
  );
};

export default Beheerdersportaal;